import axios from "axios";

export const createAxiosInstance = (options = {}) =>
  axios.create({
    ...options,
    paramsSerializer: {
      indexes: null, // array indexes format (null - no brackets, false - empty brackets, true - brackets with indexes)
    },
  });
